import {
  GetMemberQuery,
  GetMemberDocument,
  OperationInput,
  ListMemberQuery,
  ListMemberDocument,
  MemberListInput,
  MemberCountInput,
  GetMemberCountQuery,
  GetMemberCountDocument,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 会員情報を取得する
 * @param memberId: 会員ID
 * @param operationInput: 操作ログInput
 * @returns 会員情報
 */
export async function getMember(
  memberId: string,
  operationInput: OperationInput
): Promise<
  | {
      __typename?: "Member";
      address1: string;
      address2: string;
      address3?: string | null | undefined;
      name1: string;
      name2: string;
      name_kana1: string;
      name_kana2: string;
      zip_code: string;
      phone: string;
      shop_code?: string | null | undefined;
      house_card?: string | null | undefined;
    }
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const member: ApolloQueryResult<GetMemberQuery> =
      await apolloClient.query<GetMemberQuery>({
        query: GetMemberDocument,
        variables: {
          logInput: operationInput,
          member_id: memberId,
        },
        fetchPolicy: "no-cache",
      });
    return member.data.getMember;
  } catch (err: unknown) {
    console.error(err);
    if (err instanceof Error) {
      err.message = "会員情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("会員情報の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * 会員情報一覧を取得する
 * @param memberListInput: 会員情報
 * @param operationInput: 操作ログInput
 * @returns 会員一覧
 */
export async function listMember(
  memberListInput: MemberListInput,
  operationInput: OperationInput
): Promise<
  | Array<
      | {
          __typename?: "Member";
          member_id: string;
          name1: string;
          name2: string;
          name_kana1: string;
          name_kana2: string;
          zip_code: string;
          address1: string;
          address2: string;
          address3?: string | null | undefined;
          phone: string;
          house_card?: string | null | undefined;
        }
      | null
      | undefined
    >
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const member: ApolloQueryResult<ListMemberQuery> =
      await apolloClient.query<ListMemberQuery>({
        query: ListMemberDocument,
        variables: {
          logInput: operationInput,
          input: memberListInput,
        },
        fetchPolicy: "no-cache",
      });
    return member.data.listMember;
  } catch (err: unknown) {
    console.error(err);
    if (err instanceof Error) {
      err.message = "会員一覧の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("会員一覧の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * 会員情報一覧の件数を取得する
 * @param memberCountInput: 会員情報
 * @returns 件数
 */
export async function getMemberCount(
  memberCountInput: MemberCountInput
): Promise<number> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const member: ApolloQueryResult<GetMemberCountQuery> =
      await apolloClient.query<GetMemberCountQuery>({
        query: GetMemberCountDocument,
        variables: {
          input: memberCountInput,
        },
        fetchPolicy: "no-cache",
      });

    return member.data.getMemberCount!.count;
  } catch (err: unknown) {
    console.error(err);
    if (err instanceof Error) {
      err.message = "会員一覧の件数取得に失敗しました。";
      throw err;
    } else {
      throw new Error("会員一覧の件数取得に失敗しました。（Unknown error）");
    }
  }
}
